import { chartConfig } from "../chart.commonConfig";
import { lastPageChartConfig } from "./thirdPageChart.config";
import { PDF_CONSTANT } from "../../../../constant";
import { chartsLoadedAction } from "../../../../actions/reports.action";
import { CATEGORY_LIMIT } from "../chartHelper";

export const THIRD_BAR_CHART_HELPER = data => {
  let barChartConstantValues = {};

  const BAR_CHART = {
    chart: {
      ...chartConfig.chart,
      ...lastPageChartConfig.chart,
      events: {
        load: () => {
          chartsLoadedAction({
            type: PDF_CONSTANT.LAST_PAGE.THIRD._SUCCESS
          });
        },
        render: function() {
          const titleTag = document.getElementById("second-section-title");
          const titleComponentTag = document.getElementById(
            "second-section-title-component"
          );
          const subTitleComponentTag = document.getElementById(
            "third-page-second-section-subtitle-1"
          );
          const labelComponent = document.getElementById(
            "third-page-second-section-labels"
          );

          titleTag.innerHTML = "";
          labelComponent.innerHTML = "";
          titleComponentTag.innerHTML = `SECTOR DISTRIBUTION : ${
            barChartConstantValues.totalProjects
          } RESOLVED PROJECTS (ALL ISSUES RESOLVED)`;
          subTitleComponentTag.innerHTML = `Sector wise break-up of ${
            barChartConstantValues.totalProjects
          } projects where all issues are resolved under PMG mechanism`;
          //
          const Data = [
            {
              title: `${barChartConstantValues.totalProjects} PROJECTS`,
              subtitle: `Resolved Projects (all issues resolved)`
            },
            {
              title: `INR 
                            ${(
                              barChartConstantValues.totalProjectsCost / 100000
                            )
                              .toFixed(2)
                              .toString()
                              .replace(/,/g, ".")} 
                        LAKH CR.`,
              subtitle: `Anticipated Investment in Resolved Projects`
            },
            {
              title: `${barChartConstantValues.totalIssues} ISSUES`,
              subtitle: `Number of Issues resolved under PMG mechanism`
            }
          ];

          Data.forEach(function(series) {
            const labelElem = document.createElement("div");
            const titleElem = document.createElement("h4");
            const subElem = document.createElement("span");
            titleElem.innerHTML = series.title;
            subElem.innerHTML = series.subtitle;
            labelElem.className = "col section-third-headers";
            labelElem.appendChild(titleElem);
            labelElem.appendChild(subElem);
            titleTag.appendChild(labelElem);
          });

          //
          this.series.forEach(val => {
            const parent = document.createElement("div");
            const shape = document.createElement("span");
            const name = document.createElement("span");
            name.innerHTML = val.name;
            shape.style.backgroundColor = val.color;
            shape.className = "static-label-shape";
            parent.className = "static-label-parent";
            parent.appendChild(shape);
            parent.appendChild(name);
            labelComponent.appendChild(parent);
          });
        }
      }
    },
    title: {
      text: " "
    },
    subtitle: {
      text: ""
    },
    xAxis: {
      visible: false,
      categories: []
    },
    yAxis: {
      // Primary yAxis
      labels: {
        format: `{value}`,
        style: {
          color: "#141414"
        }
      },
      title: {
        text: "Number of Project(s)"
      },
      min: 0,
      max: 0,
      className: "bar-label"
    },
    legend: {
      enabled: false
    },
    tooltip: {
      enabled: false
    },
    series: [{ name: "Projects", data: [] }],
    plotOptions: {
      series: {
        groupPadding: 0,
        animation: false
      }
    },
    tooltip: {
      formatter: function() {
        return `
              <b>${BAR_CHART.xAxis.categories[this.colorIndex]}</b><br />
              <b>Projects: ${this.y}</b>
            `;
      }
    }
  };

  try {
    const {
      totalIssues = 0,
      totalProjects = 0,
      totalProjectsCost = 0,
      projectSectorDTOS: list
    } = data;
    const projectArr = [];
    const seriesArr = [];
    let otherProjects = 0;
    list.forEach(({ sector, projectCost, projectCount }, index) => {
      projectArr.push(projectCount);
      if (index >= CATEGORY_LIMIT) {
        otherProjects += projectCount;
        seriesArr[CATEGORY_LIMIT] = seriesArr[CATEGORY_LIMIT] || {};
        seriesArr[CATEGORY_LIMIT]["name"] = "Others";
        seriesArr[CATEGORY_LIMIT]["data"] = [otherProjects];
        seriesArr[CATEGORY_LIMIT]["dataLabels"] = { enabled: true };
      } else {
        seriesArr.push({
          name: sector,
          data: [projectCount],
          dataLabels: { enabled: true }
        });
        BAR_CHART.xAxis.categories.push(sector);
      }
    });
    BAR_CHART.series = seriesArr;
    BAR_CHART.xAxis.categories[9] = "Others";
    BAR_CHART.yAxis.max = Math.max(...projectArr);
    barChartConstantValues = { totalIssues, totalProjects, totalProjectsCost };
    return BAR_CHART;
  } catch (error) {
    console.error(error);
  }
};
